import type { ISelectListItem, ISelectListNumberItem } from "../models";

export const toSelectListItem = (dto: {
  id: number;
  name: string;
}): ISelectListNumberItem => {
  const selectItem: ISelectListNumberItem = {
    value: dto.id,
    label: dto.name,
  };
  return selectItem;
};

/** Shows the translated `label`; the code `name` stays searchable and appears on hover. */
export const toTranslatedSelectListItem = ({
  id,
  name,
  label,
}: {
  id: number;
  name: string;
  label: string;
}): ISelectListItem => {
  const selectItem: ISelectListItem = {
    value: id,
    label,
    technicalName: name,
  };
  return selectItem;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const comparableNumber = (val: any): number => {
  if (!val) {
    return 0;
  }

  return +val || 0;
};
